<template>
    <Section id="faq">
        <template #section>
            {{ $t('budgets_landing_page.faq') }}
        </template>
        <template #title>
            {{ $t('budgets_landing_page.faq_subtitle') }}
        </template>
        <div class="lg:grid-cols-3 lg:gap-12 grid gap-8">
            <div v-for="faqsChunk in faqsChunks">
                <ul class="flex flex-col space-y-8">
                    <li v-for="faq in faqsChunk">
                        <h4 class="mt-0 leading-6">
                            {{ faq.question }}
                        </h4>
                        <p class="mb-0 text-sm tracking-tight">
                            {{ faq.answer }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </Section>
</template>

<script>
import Section from '../../../../shared/section.vue';

export default {
    components: {
        Section,
    },

    computed: {
        faqs() {
            const faqs = [
                {
                    question: this.$t('budgets_landing_page.faq_1_question'),
                    answer: this.$t('budgets_landing_page.faq_1_answer'),
                },
                {
                    question: this.$t('budgets_landing_page.faq_2_question'),
                    answer: this.$t('budgets_landing_page.faq_2_answer'),
                },
                {
                    question: this.$t('budgets_landing_page.faq_3_question'),
                    answer: this.$t('budgets_landing_page.faq_3_answer'),
                },
                {
                    question: this.$t('budgets_landing_page.faq_4_question'),
                    answer: this.$t('budgets_landing_page.faq_4_answer'),
                },
                {
                    question: this.$t('budgets_landing_page.faq_5_question'),
                    answer: this.$t('budgets_landing_page.faq_5_answer'),
                },
                {
                    question: this.$t('budgets_landing_page.faq_6_question'),
                    answer: this.$t('budgets_landing_page.faq_6_answer'),
                },
                {
                    question: this.$t('budgets_landing_page.faq_7_question'),
                    answer: this.$t('budgets_landing_page.faq_7_answer'),
                },
            ];

            return faqs;
        },

        faqsChunks() {
            return this.chunkArray(this.faqs, 3);
        },
    },

    methods: {
        chunkArray(arr, chunkCount) {
            const chunks = [];
            while(arr.length) {
                const chunkSize = Math.ceil(arr.length / chunkCount--);
                const chunk = arr.slice(0, chunkSize);
                chunks.push(chunk);
                arr = arr.slice(chunkSize);
            };
            return chunks;
        },
    },
};
</script>
